import { Badge } from '@/components/ui/badge';
import type { BookingStatus } from '@/types/events';
import { BOOKING_STATUS_LABELS } from '@/types/events';

interface BookingStatusBadgeProps {
  status: BookingStatus;
}

export function BookingStatusBadge({ status }: BookingStatusBadgeProps) {
  const variants: Record<BookingStatus, 'default' | 'secondary' | 'destructive' | 'outline'> = {
    pending: 'outline',
    confirmed: 'default',
    cancelled: 'secondary',
  };

  return (
    <Badge variant={variants[status]}>
      {BOOKING_STATUS_LABELS[status]}
    </Badge>
  );
}
